import useStore from "../../data/store";

export default class BaseRepository {
  static modelClass;

  async createRecord(data, settings = {}) {
    const record = await useStore.getState().createRecord(this.modelName, data);
    return await record.save(settings);
  }

  async createBulk(data, settings = {}) {
    return await useStore.getState().createBulk(this.modelName, data, settings);
  }

  async getCreateRequestObject() {
    return new this.constructor.requestClass();
  }

  async findRecord(id, options = {}) {
    if (!id) {
      throw new Error(`'id' is required in BaseRepository.findRecord`);
    }
    return await useStore.getState().findRecord(this.modelName, id, options);
  }

  async getOptions() {
    return await useStore.getState().getOptions(this.modelName);
  }

  async get() {
    return await useStore.getState().get(this.modelName);
  }

  async query(query = {}, options = {}) {
    if (options && Object.keys(options) && Object.keys(options).length > 0) {
      return await useStore.getState().findAll(this.modelName, query, options);
    } else {
      return await useStore.getState().findAll(this.modelName, query);
    }
  }

  async patch(id, body, options = {}) {
    return await useStore.getState().patch(this.modelName, id, body, options);
  }

  async getFirstRecord(query = {}, options = {}) {
    const res = await this.query(query, options);
    if (!res || res.length === 0) {
      throw new Error(`No results found`);
    } else {
      return res[0];
    }
  }

  async delete(id, settings = {}) {
    return await useStore.getState().deleteRecord(this.modelName, id, settings);
  }

  async getRawData() {
    return await useStore.getState().getRawData(this.modelName);
  }

  async getTotalCount() {
    return await useStore.getState().getTotalCount(this.modelName);
  }

  async getNextPage() {
    return await useStore.getState().getNextPage(this.modelName);
  }

  async upload(body, params = {}, method) {
    return await useStore.getState().upload(this.modelName, body, params, method);
  }

  async post(body, settings = {}) {
    return await useStore.getState().post(this.modelName, body, settings);
  }
}
